// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"placeholder_placeholder__J4XC9 m-10 p-10 text text_type_main-default"};